import information from "../../data/information.js";

export default {
  data: () => ({
    info: [],
  }),
  created() {
    const targetDate = location.pathname.split('/').pop(); // ファイルの名前を取得
    this.info = information.infos.filter(item => item.date === targetDate);
  },
  methods: {
    formatDate(date) {
      const year = date.slice(0, 4);
      const month = parseInt(date.slice(4, 6), 10);
      const day = parseInt(date.slice(6, 8), 10);

      const months = [
        "1月", "2月", "3月", "4月", "5月", "6月",
        "7月", "8月", "9月", "10月", "11月", "12月"
      ];

      return `${year}年${months[month - 1]}${day}日`;
    },
  },
};
